
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateTagForm } from '@/services/QA/tag/forms/CreateTagForm';
import { TagRepositoryInterface } from '@/services/QC-V2/tag/interfaces';

@Component({
  inject: [
    'tagRepositoryV2',
  ],
})
export default class CreateTag extends Vue {
  private readonly tagRepositoryV2!: TagRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<CreateTagForm> = new WPXFormValue(CreateTagForm);

  public created(): void {
    this.loading = false;
  }

  private async createTag(): Promise<void> {
    try {
      await this.tagRepositoryV2.createTag({
        label: this.form.data.label,
        color: this.form.data.color,
      });

      this.$successDialog.show(`Tag '${this.form.data.label}' has been created`);
      await this.$router.push({ name: 'tags' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
